import POVBlock from '../POVBlock/POVBlock';
import Insight from '../Insight/Insight';
import Quote from "../Quote/Quote";
import FooterCta from "../FooterCta/FooterCta";

class AboutUsCoreModel {
  constructor(contentfulNode) {
    this.pageTitle = contentfulNode?.pageTitle;
    this.metaDescription = contentfulNode?.metaDescription;
    this.slug = contentfulNode?.slug;
    this.heroSectionLabel = contentfulNode?.heroSectionLabel;
    this.heroSectionBody = contentfulNode?.heroSectionBody;
    this.heroSectionImages = contentfulNode?.heroSectionImages;
    this.spotlight = contentfulNode?.spotlight?.internal?.type === 'ContentfulPointOfViewBlock' ?
      new POVBlock(contentfulNode.spotlight) : contentfulNode?.spotlight?.internal?.type === 'ContentfulQuoteBlock' ?
        new Quote(contentfulNode.spotlight) : null;
    this.primaryHighlight = contentfulNode?.primaryHighlight ? new POVBlock(contentfulNode.primaryHighlight) : null;
    this.videoCarousel = contentfulNode?.videoCarousel;
    this.featuredContent = contentfulNode?.featuredContent ? contentfulNode.featuredContent : null;
    this.featuredContentDownload = contentfulNode?.featuredContentDownload;
    this.exploreMore = contentfulNode?.exploreMore?.map(povBlock => new POVBlock(povBlock));
    this.editorial = contentfulNode?.editorial ? new POVBlock(contentfulNode.editorial) : null;
    this.relatedInsights = contentfulNode?.relatedInsights?.map(insight => new Insight(insight));
    this.footerCta = contentfulNode?.footerCta ? new FooterCta(contentfulNode.footerCta) : null;
  }
}

export default AboutUsCoreModel;
